import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/dating/index'
import center from '@/components/dating/center'
import recharge from '@/components/dating/recharge'
import pay from '@/components/dating/pay'
import search from '@/components/dating/search'
import care from '@/components/dating/care'
import paySucc from '@/components/dating/paySucc'
import bindPhone from '@/components/dating/bindPhone'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/center',
      name: 'center',
      component: center
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: recharge
    },
    {
      path: '/pay',
      name: 'pay',
      component: pay
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/care',
      name: 'care',
      component: care
    },
    {
      path: '/paySucc',
      name: 'paySucc',
      component: paySucc
    },
    {
      path: '/bindPhone',
      name: 'bindPhone',
      component: bindPhone
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js